import React from "react";
import { Input, Radio} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setMainOption, setSubOption, setComments } from "../../../redux/actions/mobileTelephonyAction";
import { setMobileTelephonyFeedback } from "../../../redux/actions/feedbackActions";
import { useMediaQuery } from "react-responsive";
const mainOptions = [
  { value: 1, label: "Support" },
  { value: 2, label: "Service" },
  { value: 3, label: "Process" },
  { value: 4, label: "Platform" },
];

const translations = {
  English: {
    title: "Mobile Telephony Service",
    selectCategory: "Select category for which you would like to provide feedback on?",
    shareExperience: "Please tell us more about your experience:",
    commentsPlaceholder: "Comments",
    notificationError: "Please fill in the comments field as it is mandatory.",
  },
  Japanese: {
    title: "モバイル電話サービス",
    selectCategory: "フィードバックを提供したいカテゴリを選択してください。",
    shareExperience: "ご意見をお聞かせください:",
    commentsPlaceholder: "コメント",
    notificationError: "コメント欄を入力してください。これは必須項目です。",
  },
  Chinese: {
    title: "移动电话服务",
    selectCategory: "请选择您想提供反馈的类别？",
    shareExperience: "请分享您的体验:",
    commentsPlaceholder: "评论",
    notificationError: "请填写评论，因为它是必填项。",
  },
  Dutch: {
    title: "Mobiele Telefonie Service",
    selectCategory: "Selecteer de categorie waarover u feedback wilt geven.",
    shareExperience: "Deel uw ervaring:",
    commentsPlaceholder: "Opmerkingen",
    notificationError: "Vul het opmerkingenveld in, want dit is verplicht.",
  },
  German: {
    title: "Mobiltelefondienst",
    selectCategory: "Wählen Sie die Kategorie aus, zu der Sie Feedback geben möchten.",
    shareExperience: "Bitte teilen Sie Ihre Erfahrungen mit:",
    commentsPlaceholder: "Kommentare",
    notificationError: "Bitte füllen Sie das Kommentarfeld aus, da es erforderlich ist.",
  },
  Spanish: {
    title: "Servicio de Telefonía Móvil",
    selectCategory: "Seleccione la categoría sobre la que desea dar su opinión.",
    shareExperience: "Por favor, comparta su experiencia:",
    commentsPlaceholder: "Comentarios",
    notificationError: "Por favor, rellene el campo de comentarios, ya que es obligatorio.",
  },
  French: {
    title: "Service de Téléphonie Mobile",
    selectCategory: "Sélectionnez la catégorie pour laquelle vous souhaitez donner un avis.",
    shareExperience: "Veuillez partager votre expérience :",
    commentsPlaceholder: "Commentaires",
    notificationError: "Veuillez remplir le champ des commentaires, car il est obligatoire.",
  },
};

const subOptions = {
  1: [
    { value: "a", label: "Mobile telephony support quality/reachability" },
    { value: "b", label: "Knowledge articles, guidelines" },
  ],
  2: [
    { value: "c", label: "Signal coverage, quality of mobile carrier service" },
    { value: "d", label: "Plan/tariff/packages" },
  ],
  3: [
    { value: "e", label: "New service, port-in, cancel service, port-out, plan changes/upgrades" },
    { value: "f", label: "Device replacement" },
  ],
  4: [
    { value: "g", label: "Mobility portal" },
  ],
};

const MobileTelephony = () => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const selectedMainOption = useSelector((state) => state.mobileTelephony.mainOption);
  const selectedSubOption = useSelector((state) => state.mobileTelephony.subOption);
  const comments = useSelector((state) => state.mobileTelephony.comments);
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);

  const translation = translations[selectedLanguage] || translations.English;

  const onMainOptionChange = (e) => {
    const selectedOption = mainOptions.find((option) => option.value === e.target.value);
    dispatch(setMainOption(selectedOption.value));
    dispatch(
      setMobileTelephonyFeedback(
        "Mobile telephony service",
        selectedOption.label,
        selectedSubOption,
        comments
      )
    );
  };

  const onSubOptionChange = (value) => {
    const selectedSubOption = subOptions[selectedMainOption].find((option) => option.value === value);
    dispatch(setSubOption(selectedSubOption.value));
    dispatch(
      setMobileTelephonyFeedback(
        "Mobile telephony service",
        mainOptions.find((option) => option.value === selectedMainOption)?.label,
        selectedSubOption.label,
        comments
      )
    );
  };

  const onCommentsChange = (e) => {
    const commentText = e.target.value.trimStart();
    const selectedMainCategory = mainOptions.find(
      (option) => option.value === selectedMainOption
    );
    const selectedSubCategory = subOptions[selectedMainOption]?.find(
      (option) => option.value === selectedSubOption
    );
    dispatch(setComments(commentText));
    dispatch(
      setMobileTelephonyFeedback(
        "Mobile telephony service",
        selectedMainCategory?.label,
        selectedSubCategory?.label,
        commentText
      )
    );
  };  

  return (
    <section style={isMobile ? {marginRight:'4%',marginLeft:'2%',marginTop:"20px"  }:{marginRight:'0%' }}>
      <h3>{translation.title}</h3>

      <h2 style={{ paddingTop: "50px" }}>
        {translation.selectCategory}
      </h2>

      {/* Main options */}
      <div>
        <Radio.Group onChange={onMainOptionChange} value={selectedMainOption}>
          {mainOptions.map((option) => (
            <Radio key={option.value} value={option.value}>
              {option.label}
            </Radio>
          ))}
        </Radio.Group>
      </div>

      {selectedMainOption && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          {subOptions[selectedMainOption].map((option) => (
            <div
              key={option.value}
              onClick={() => onSubOptionChange(option.value)}
              style={{
                border: selectedSubOption === option.value ? "2px solid #1890ff" : "1px solid #d9d9d9",
                borderRadius: "8px",
                padding: "12px",
                width: "calc(50% - 10px)",
                textAlign: "center",
                cursor: "pointer",
                backgroundColor: selectedSubOption === option.value ? "#e6f7ff" : "white",
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}

      {selectedSubOption && (
        <div style={{ paddingTop: "30px" }}>
          <p>
            {translation.shareExperience} <span style={{ color: "red" }}>*</span>
          </p>
          <Input.TextArea
            placeholder={translation.commentsPlaceholder}
            style={{ height: "60px", resize: "none" }}
            value={comments}
            onChange={onCommentsChange}
          />
        </div>
      )}

      
    </section>
  );
};

export default MobileTelephony;
